module.exports = __webpack_public_path__ + "img/iso-14001.316aa7e.webp";